import React, { useContext } from "react";
import { IntContainer, Title, StyledP, StyledGoBack } from "./setup.style";
import LeftArrow from "../../img/Left_Arrow.svg";
import FacebookLogin from "react-facebook-login";
import FixelDataContext from "../../context/FixelDataContext";
import { useHistory } from "react-router-dom";

const IntFacebook = () => {
  const history = useHistory();
  const { fullFixelData, setFullFixelData } = useContext(FixelDataContext);
  const goToSelectFBAccount = async (fbRes) => {
    console.log("🚀 ~ file: IntFacebook.js ~ line 12 ~ selectFBAccount ~ fbRes", fbRes);
    if (fbRes.accessToken && fbRes.userID) {
      sessionStorage.fbId = fbRes.userID; // .providerData.filter(pd=>pd.providerId=='facebook.com')[0].uid
      sessionStorage.fbToken = fbRes.accessToken; // await fbUser.getIdToken();
      history.push("/setup/facebook/selectAccount");
    } else {
      setFullFixelData({ ...fullFixelData, FBIntegrationStatus: "failed" });
      history.push("/dashboard");
    }
  };
  return (
    <IntContainer>
      <StyledGoBack onClick={() => history.goBack()}>
        <img src={LeftArrow} alt="arrow left" /> Go Back
      </StyledGoBack>
      <Title align="left">Connect Fixel with a Facebook&nbsp;account</Title>
      <StyledP>Create Fixel audiences with one click using this integration.</StyledP>
      <StyledP>
        These audiences can be used for both <span>Remarketing</span> and <span>Lookalike purposes</span>
      </StyledP>
      <FacebookLogin
        appId="471655140041337"
        // autoLoad={true}
        // fields="name,email,picture"
        scope="ads_management"
        callback={goToSelectFBAccount}
        textButton="Integrate"
        cssClass="facebook-button"
        // icon="fa-facebook"
      />
    </IntContainer>
  );
};
export default IntFacebook;
